import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_GetExperimentResultsCommand, se_GetExperimentResultsCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class GetExperimentResultsCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Evidently", "GetExperimentResults", {})
    .n("EvidentlyClient", "GetExperimentResultsCommand")
    .f(void 0, void 0)
    .ser(se_GetExperimentResultsCommand)
    .de(de_GetExperimentResultsCommand)
    .build() {
}
